import { useEffect } from "react";
import { Geolocation } from "@capacitor/geolocation";
import { Capacitor } from "@capacitor/core";

export function useStartupLocationPermission() {
    useEffect(() => {
        // Web browsers handle permission lazily
        if (Capacitor.getPlatform() === "web") return;

        const requestPermission = async () => {
            try {
                const status = await Geolocation.checkPermissions();

                if (status.location !== "granted") {
                    await Geolocation.requestPermissions({
                        permissions: ["location"],
                    });
                }
            } catch (err) {
                console.warn("Location permission check failed:", err);
            }
        };

        // Small delay ensures Android bridge is ready
        setTimeout(requestPermission, 500);
    }, []);
}
